import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { CourseTemplate } from 'app/shared/models';

@Injectable()
export class CourseTemplateService {
  private courseTemplates: CourseTemplate[];
  private courseTemplateApiUrl = this.config.getConfig('apiUrl') + '/v1/CourseTemplates';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization-ApiKey': this.config.getConfig('apiKey')
  });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getCourseTemplate(templateId: number): CourseTemplate {
    return this.courseTemplates.find(courseTemplate => courseTemplate.Id === templateId);
  }

  public getCourseTemplates(): Promise<CourseTemplate[]> {
    return this.courseTemplates
      ? Promise.resolve(this.courseTemplates)
      : this.http
          .get<CourseTemplate[]>(this.courseTemplateApiUrl, { headers: this.headers })
          .toPromise()
          .then(response => {
            this.courseTemplates = response;
            return this.courseTemplates;
          })
          .catch(error => Promise.reject(error.message || error));
  }
}
